import { LoadingShimmer } from "@newsela/angelou";

import {
  contentContainerCss,
  rowContainerCss,
} from "../ContentPreviewRow.style";
import {
  loadingCardShimmerCss,
  rowHeadingShimmerCss,
} from "./LoadingRow.style";

interface LoadingRowProps {
  numberOfCards: number;
}

export const LoadingRow = ({ numberOfCards }: LoadingRowProps) => {
  return (
    <div css={rowContainerCss}>
      <LoadingShimmer __cssFor={rowHeadingShimmerCss} />
      <div css={contentContainerCss}>
        {Array.from<number>({ length: numberOfCards }).map((_, index) => (
          <LoadingShimmer key={index} __cssFor={loadingCardShimmerCss} />
        ))}
      </div>
    </div>
  );
};

export default LoadingRow;
